import React, { useEffect } from "react";

import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
const GalleryV1 = ({images}) =>{
  let  image = [
    {
      original: "/images/noimg.jpg",
      thumbnail: "/images/noimg.jpg",
      originalAlt: "alt",
      thumbnailAlt: "alt",
      originalTitle: "title",
      thumbnailTitle: "title"
    }
];
const onMouseOver=(e)=>{
    console.log(e);
}
  return(
        <ImageGallery items={images.length>0?images:image} 
          showThumbnails={true}
          thumbnailPosition='left'
          lazyLoad={true}
          showFullscreenButton={true}
          showPlayButton={false}
          slideOnThumbnailOver={true}
          showNav={false}
          showNavThumbnai={true}
        />
  );
}

export default GalleryV1